import Navbar from "./Navbar";
import Footer from "./Footer";

export const PageShell = ({ children, testId = "page-shell" }) => {
  return (
    <div
      data-testid={testId}
      className="min-h-screen bg-black text-stone-200 flex flex-col hex-bg"
    >
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default PageShell;
